import {
  projectsLoading,
  projectsError,
  setProjectsList,
} from "../../slices/projectsSlice";
import {
  getService,
  createService,
  deleteAllService,
  deleteRowService,
  updateService,
  softDeleteService,
  softDeleteAllService,
  restoreRowService,
  restoreAllService,
} from "../../services/projects";

export const getAction = () => async (dispatch) => {
  dispatch(projectsLoading());
  try {
    const response = await getService();
    if (response?.error) {
      dispatch(projectsError(response.error));
      return;
    } else {
      dispatch(setProjectsList(response));
      return;
    }
  } catch (error) {
    dispatch(projectsError(error.message));
    return;
  }
};

export const createAction = (formData) => async (dispatch) => {
  dispatch(projectsLoading());
  try {
    const response = await createService(formData);
    if (response?.error) {
      dispatch(projectsError(response.error));
      return;
    } else {
      dispatch(getAction());
      return;
    }
  } catch (error) {
    dispatch(projectsError(error.message));
    return;
  }
};

export const updateAction = (formData) => async (dispatch) => {
  const table = formData.get("table");
  const id = formData.get("id");
  dispatch(projectsLoading());
  try {
    const response = await updateService(formData);
    if (response?.message) {
      dispatch(getAction());
      return;
    } else {
      dispatch(
        projectsError(`Failed to update row with ID ${id} in ${table} table`)
      );
      return;
    }
  } catch (error) {
    dispatch(projectsError(error.message));
    return;
  }
};

export const softDeleteAction = (table, id, username) => async (dispatch) => {
  dispatch(projectsLoading());
  try {
    const response = await softDeleteService(table, id, username);
    if (response?.message) {
      dispatch(getAction());
      return;
    } else {
      dispatch(
        projectsError(
          `Failed to softdelete row with ID ${id} in ${table} table`
        )
      );
      return;
    }
  } catch (error) {
    dispatch(projectsError(error.message));
    return;
  }
};

export const softDeleteAllAction = (table, username) => async (dispatch) => {
  dispatch(projectsLoading());
  try {
    const response = await softDeleteAllService(table, username);
    if (response?.message) {
      dispatch(getAction());
      return;
    } else {
      dispatch(projectsError(`Failed to delete records in ${table} table`));
      return;
    }
  } catch (error) {
    dispatch(projectsError(error.message));
    return;
  }
};

export const deleteRowAction = (table, id, username) => async (dispatch) => {
  dispatch(projectsLoading());
  try {
    const response = await deleteRowService(table, id, username);
    if (response?.message) {
      dispatch(getAction());
      return;
    } else {
      dispatch(
        projectsError(`Failed to delete row with ID ${id} in table ${table}`)
      );
      return;
    }
  } catch (error) {
    dispatch(projectsError(error.message));
    return;
  }
};

export const deleteAllAction = (table, type, username) => async (dispatch) => {
  dispatch(projectsLoading());
  try {
    const response = await deleteAllService(table, type, username);
    if (response?.message) {
      dispatch(getAction());
      return;
    } else {
      dispatch(
        projectsError(
          `Failed to delete records in ${table} table of type ${type}`
        )
      );
      return;
    }
  } catch (error) {
    dispatch(projectsError(error.message));
    return;
  }
};

export const restoreRowAction = (table, id, username) => async (dispatch) => {
  dispatch(projectsLoading());
  try {
    const response = await restoreRowService(table, id, username);
    if (response?.message) {
      dispatch(getAction());
      return;
    } else {
      dispatch(
        projectsError(`Failed to recover row with ID ${id} in ${table} table`)
      );
      return;
    }
  } catch (error) {
    dispatch(projectsError(error.message));
    return;
  }
};

export const restoreAllAction = (table, type, username) => async (dispatch) => {
  dispatch(projectsLoading());
  try {
    const response = await restoreAllService(table, type, username);
    if (response?.message) {
      dispatch(getAction());
      return;
    } else {
      dispatch(
        projectsError(
          `Failed to recover records in ${table} table of type ${type}`
        )
      );
      return;
    }
  } catch (error) {
    dispatch(projectsError(error.message));
    return;
  }
};
